import React from "react"
import FadeIn from "../general/fadein.tsx"
import FadeInTop from "../general/fadeintop.tsx"

import sparksocial from "../../images/sparksocial/sparksocial_large.png"
import sparksocialplanning from "../../images/sparksocial/sparksocialplanning.png"
import mongodb from "../../images/sparksocial/mongodb.png"
function SparkSocial() {
    const transition = {
        transition: ".3s"
    }
    const project_structure = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Project structure diagram to ensure that all key components in our determined Minimum Viable Product were met.</p>

        <img
            className=" h-108 rounded-md object-fill object-center pt-5 shadow-xl"
            src={sparksocialplanning}
            alt="Planning Diagram Tree"
        />
    </div>)
    const database_structure = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Database structure diagram to visualize how the backend would function and communicate with the frontend.</p>

        <img
            className=" h-108 rounded-md object-fill object-center pt-5 shadow-xl"
            src={mongodb}
            alt="Face Detection"
        />
    </div>)
    const top = (<div className="grid grid-cols-2 w-2/3 m-auto mt-5 ">
        <div className="text-center m-auto p-5 ">
            <img
                className=" h-96 w-96 rounded-full object-fill object-center"
                src={sparksocial}
                alt="Spark Social Logo"
            />

        </div>
        <div className="flex flex-row text-left  p-5 items-center">
            <div>
                <h1 className="text-3xl sm:text-5xl font-semibold">SparkSocial</h1>
                <a style={transition} className=" text-xl underline text-red-600 hover:text-red-800" href="https://github.com/Rishthegreat/fbla">GitHub</a>
                <p className="text-l sm:text-2xl">Created with React Native, MongoDB, Python Flask, and GraphQL.</p>
            </div>
        </div>
    </div>)
    return (
        <>
            <div className="divide-y divide-black/50 w-3/4 m-auto">
                <FadeInTop html={top}/>
                <div className="hidden lg:grid grid-cols-2 pb-10">
                    <FadeIn html={project_structure} left={true}/>
                    <FadeIn html={database_structure} left={false}/>
                    
                    
                </div>
            </div>
        </>
    );
}
export default SparkSocial;